// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store/index'
import ElementUI from 'element-ui'
import VueCookies from 'vue-cookies'
import 'element-ui/lib/theme-chalk/index.css'
import '@/assets/css/common.css'
import '@/assets/fonts/iconfont'
import headerPage from '@/components/header_page'
require('echarts-wordcloud')
import dayjs from 'dayjs'
dayjs.locale('zh-cn')
Vue.prototype.dayjs = dayjs

Vue.config.productionTip = false

Vue.use(ElementUI)
Vue.use(VueCookies)
Vue.$cookies.config('14d')

Vue.prototype.$cookie = VueCookies

Vue.component('header-page', headerPage)

/* eslint-disable no-new */
new Vue({
    el: '#app',
    router,
    store,
    components: { App },
    template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js